import { TWaterActivitiesIds, idWaterActivity } from '@ve/pages/serp/components/filters/filterWaterActivities/common';

export default (ids: number[]): TWaterActivitiesIds[] => {
    const attributeIds = new Set(ids);
    const result: TWaterActivitiesIds[] = [];

    if (attributeIds.has(60)) { // Открытый бассейн
        result.push(idWaterActivity.openPool);
    }
    if (attributeIds.has(59)) { // Крытый бассейн
        result.push(idWaterActivity.closePool);
    }
    if (attributeIds.has(174)) { // Бассейн с подогревом
        result.push(idWaterActivity.heatedPool);
    }
    if (attributeIds.has(173)) { // Бассейн с морской водой
        result.push(idWaterActivity.seaPool);
    }
    if (attributeIds.has(175)) { // Водные горки
        result.push(idWaterActivity.waterslides);
    }
    if (attributeIds.has(61)) { // Аквапарк
        result.push(idWaterActivity.aquapark);
    }
    return result;
};
